module.exports = __webpack_public_path__ + "img/neudorf-thumb.81fa879f.webp";